import React from "react";

const OverrideComplianceOfBankFilled = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      className={cls}
    >
      <path
        d="m17,1.3c.697.245,1.341.627,1.879,1.164l3.656,3.657c.537.537.919,1.182,1.165,1.878h-5.7c-.552,0-1-.449-1-1V1.3Zm1,8.7c-1.654,0-3-1.346-3-3V1h-4c-2.206,0-4,1.794-4,4v8h6.095l-1.802-1.793c-.391-.391-.391-1.024,0-1.415.391-.39,1.023-.39,1.414,0l2.799,2.801c.387.387.581.896.581,1.405,0,0,0,0,0,.001,0,0,0,0,0,.001,0,.509-.193,1.017-.58,1.404l-2.8,2.802c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.39-.391-1.023,0-1.414l1.792-1.793h-6.085v4c0,2.206,1.794,4,4,4h9c2.206,0,4-1.794,4-4v-9h-6Zm-13,9V5c0-1.538.586-2.937,1.54-4h-2.54C1.794,1,0,2.794,0,5v14c0,2.206,1.794,4,4,4h2.54c-.954-1.063-1.54-2.462-1.54-4Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default OverrideComplianceOfBankFilled;
